import { css } from 'linaria';

export const greyRoundedSquare = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  margin-right: var(--space-300);
  background-color: var(--background-secondary);
  border-radius: var(--rounding-l);
  transition: background-color 0.3s;
`;

export const routesTextRow = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;

  &:hover .${greyRoundedSquare} {
    background-color: var(--control-minor);
  }
`;
